import { FC, SVGAttributes } from "react";

interface Props {
  colors?: string[];
  width?: number;
}

const VisaIcon: FC<SVGAttributes<SVGSVGElement> & Props> = ({
  colors = ["#fff", "#1A1F71"],
  width = 96,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height="40"
    viewBox={`0 0 ${width} 40`}
    {...props}
  >
    <defs>
      <path
        id="prefix__visa_a"
        d="M37.26 0c1.774 0 3.2.378 4.308.77l-.807 3.693c-1.891-.852-3.578-.867-4.354-.8l-.189.02c-1.33.17-1.938.835-1.953 1.459-.043 2.052 6.472 2.307 6.452 6.901-.014 3.62-3.18 5.957-8.02 5.957-2.057-.022-4.043-.442-5.12-.924l.835-3.816c1.071.488 2.413 1.135 4.731 1.1 1.322-.02 2.742-.537 2.754-1.705.01-.762-.593-1.31-2.39-2.162l-.175-.086c-1.718-.844-3.883-2.23-3.855-4.653C29.503 2.364 32.707 0 37.26 0zm-9.037.318l-3.809 17.409h-4.606L23.617.318h4.606zm25.056 0L57 17.727h-4.259l-.558-2.6h-5.908l-.96 2.6h-4.838l6.911-16.133C47.718.82 48.465.318 49.35.318h3.93zm-45.333 0c.998 0 1.897.65 2.125 1.774l1.94 10.075L16.802.318h4.84l-7.464 17.409H9.31L5.637 3.833c-.222-.854-.416-1.168-1.093-1.529C3.436 1.716 1.608 1.166 0 .824L.109.317h7.837zm42.079 4.703L47.6 11.56h3.82l-1.395-6.538z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(19 11)">
      <mask id="prefix__visa_b" fill={colors[0]}>
        <use xlinkHref="#prefix__visa_a" />
      </mask>
      <path
        fill={colors[1]}
        d="M-5 -5L62 -5 62 23 -5 23z"
        mask="url(#prefix__visa_b)"
      />
    </g>
  </svg>
);

export { VisaIcon };
